import React, { ErrorInfo, ReactNode } from 'react';
import Error from './Error';

class ErrorBoundary extends React.Component<Readonly<{children: ReactNode}>, { hasError: boolean, message: null }> {
    constructor(props: Readonly<{children: ReactNode}>) {
        super(props);
        this.state = {
            hasError: false,
            message: null,
        };
    }
    static getDerivedStateFromError(error: Error): { hasError: boolean, message: null | string } {
        return { hasError: true, message: error.message };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    //   console.log(error);
    //   console.log(errorInfo);
    }
  
    render() {
        return this.state.hasError ? <Error message={ this.state.message } /> : this.props.children;
    }
}

export default ErrorBoundary;